// import { Grid } from "@mui/material";
// import React from "react";

// import { ReactComponent as ArrowUpwordCorner } from "../../images/ArrowCorner.svg";
// import { IColumns } from "../../../Components/DataGrid/WSDataGrid";
// import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
// import WSDataGridNew from "../../../Components/DataGrid/WSDataGridNew";

// export const LabRecentOrders: React.FC<any> = React.memo((props) => {
//   const columns: IColumns[] = [
//     {
//       header: "Order ID",
//       fieldName: "",
//       type: "default",
//       // sortable: true
//     },
//     {
//       header: "Patient Name",
//       fieldName: "",
//       type: "default",
//     },
//     {
//       header: "Test/Packages",
//       fieldName: "mode",
//       type: "default",
//     },

//     {
//       header: "Status",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Sample Collection",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit"].filter(Boolean),
//       // actionCallback: (action, row) => handleAction(action, row),
//       // hideSelectedActions: {
//       //     fieldToHide: [
//       //         {
//       //             field: 'status',
//       //             hideValue: ['Incomplete'],
//       //             hideActions: ['Edit']
//       //         },
//       //         // {
//       //         //     field: 'profileStatus',
//       //         //     hideValue: ['Approved'],
//       //         //     hideActions: ['Approve']
//       //         // }
//       //     ]
//       // }
//     },
//   ];

//   const filterRows: IHeaderRows[] = [
//     {
//       label: "All",
//       fieldName: "",
//       type: "dropdown",
//       options: [
//         { label: "All", value: "all" },
//         { label: "Pending", value: "pending" },
//         { label: "Processing", value: "processing" },
//         { label: "Delivered", value: "delivered" },
//       ],
//       operator: "eq",
//       rowDivision: 3,
//     },
//   ];
//   return (
//     <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//       {
//         <Grid item sm={12}>
//           <WSDataGridNew
//             columns={columns}
//             id="labrecentOrderListGrid"
//             title="Recent Orders"
//             filterFields={filterRows}
//             addButton={{ label: "New", color: "secondary" }}
//             gridHeaderSx={{
//               backgroundColor: "whitesmoke",
//               border: "1px solid whitesmoke",
//             }}
//           />
//         </Grid>
//       }
//     </Grid>
//   );
// });




import { Grid, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { ReactComponent as ArrowUpwordCorner } from "../../images/ArrowCorner.svg";
import WSDataGridNew, {
  IColumns,
} from "../../../Components/DataGrid/WSDataGridNew";
import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
import {
  getLocalValue,
  LoacalVariables,
} from "../../../commonFunctions/CommonFunctions";
import http from "../../../commonFunctions/httpClient";
import { useParams, useNavigate } from "react-router-dom"; // ✅ Added useNavigate

interface LabServiceItem {
  id: string;
  labService: {
    id: string;
    name: string;
    alsoKnownAs: string;
    finalPrice: number;
  };
}

interface OrderItem {
  id: string;
  orderNumber: string;
  status: string;
  collectionType: string;
  totalAmount: number;
  createdAt: string;
  labservice: LabServiceItem[];
}

interface RecentOrder {
  id: string;
  orderNumber: string;
  patientName: string;
  testNames: string;
  status: string;
  collectionType: string;
  totalAmount: number;
  orderDate: string;
  actions: string;
}

const LabRecentOrders: React.FC<any> = (props) => {
  const params = useParams();
  const navigate = useNavigate(); // ✅ Added navigation hook
  const [labId, setLabId] = useState<string>("");
  const [orders, setOrders] = useState<RecentOrder[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  // Get labId from localStorage or params
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    const id = userId || params?.id || "";
    console.log("Lab ID set to:", id);
    setLabId(id);
  }, []);

  // Fetch recent orders
  useEffect(() => {
    if (!labId) return;

    console.log("Fetching orders for labId:", labId);

    const fetchRecentOrders = async () => {
      setLoading(true);
      try {
        const response: any = await http.get(`lab/LabDashBoard/orders/recent/${labId}`);
        console.log("Raw API Response:", response);
        
        // Handle different response structures
        let apiData: OrderItem[] = [];
        if (response.data) {
          apiData = Array.isArray(response.data) ? response.data : [];
        } else if (Array.isArray(response)) {
          apiData = response;
        }
        
        console.log("API Data processed:", apiData);

        // Transform API data to grid format
        const transformedOrders: RecentOrder[] = apiData.map((order: OrderItem) => {
          const testNames = order.labservice?.map((service: LabServiceItem) => 
            service.labService?.name || "Unknown Test"
          ).join(", ") || "N/A";

          console.log(`Order ${order.orderNumber}:`, {
            id: order.id,
            testNames,
            status: order.status,
            collectionType: order.collectionType
          });

          return {
            id: order.id,
            orderNumber: order.orderNumber || order.id,
            patientName: "N/A", // patients is null in response
            testNames,
            status: order.status || "Unknown",
            collectionType: order.collectionType || "N/A",
            totalAmount: order.totalAmount || 0,
            orderDate: new Date(order.createdAt).toLocaleDateString(),
            actions: "",
          };
        });

        console.log("Transformed Orders:", transformedOrders);
        setOrders(transformedOrders);
      } catch (error) {
        console.error("Failed to fetch recent orders:", error);
        setOrders([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentOrders();
  }, [labId]);

  // ✅ UPDATED: View action handler
  const handleAction = useCallback((action: string, row: RecentOrder) => {
    if (action === "View") {
      console.log("View order:", row.id);
      navigate(`/lab-orders/list/view/${row.id}`); // ✅ Navigate to view page
    }
  }, [navigate]);

  const columns: IColumns[] = [
    {
      header: "Order ID",
      fieldName: "orderNumber",
      type: "default",
    },
    {
      header: "Patient Name",
      fieldName: "patientName",
      type: "default",
    },
    {
      header: "Test/Packages",
      fieldName: "testNames",
      type: "default",
    },
    {
      header: "Status",
      fieldName: "status",
      type: "status",
    },
    {
      header: "Sample Collection",
      fieldName: "collectionType",
      type: "status",
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["View"], // ✅ Changed from "Edit" to "View"
      actionCallback: handleAction, // ✅ Updated callback
    },
  ];

  const filterRows: IHeaderRows[] = [
    {
      label: "Status",
      fieldName: "status",
      type: "dropdown",
      options: [
        { label: "All", value: "" },
        { label: "OrderPlaced", value: "OrderPlaced" },
        { label: "Processing", value: "Processing" },
        { label: "Completed", value: "Completed" },
      ],
      operator: "eq",
      rowDivision: 3,
    },
    {
      label: "Collection Type",
      fieldName: "collectionType",
      type: "dropdown",
      options: [
        { label: "All", value: "" },
        { label: "Home", value: "Home" },
        { label: "Center", value: "Center" },
      ],
      operator: "eq",
      rowDivision: 3,
    },
  ];

  console.log("Rendering with orders:", orders.length, "loading:", loading);

  if (loading) {
    return (
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12}>
          <div style={{ padding: '20px', textAlign: 'center' }}>
            Loading recent orders...
          </div>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      sx={{
        px: 2,
        py: 2,
        backgroundColor: "#ffffff",
        borderRadius: "12px 12px 0 0",
      }}
    >
      <Grid item>
        <Typography fontSize={20} fontWeight={600}>
          Recent Lab Order
        </Typography>
       
      </Grid>
   </Grid>
    <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
      <Grid item sm={12}>
        <WSDataGridNew
          columns={columns}
          id="labrecentOrderListGrid"
          title="Recent Orders"
          data={orders}
          filterFields={filterRows}
          addButton={{ label: "New", color: "secondary" }}
          gridHeaderSx={{
            backgroundColor: "whitesmoke",
            border: "1px solid whitesmoke",
          }}
        />
      </Grid>
    </Grid>
    </>
  );
};

export { LabRecentOrders };
